<a [routerLink]="['/']">
  <img src="./assets/images/logos/logo_dm_light.svg" class="align-middle m-2 logo-full" alt="logo" style="height: 30px;"/>
  <img src="./assets/images/logos/logo_dm_sm.svg" class="align-middle m-2 logo-mini" alt="logo" style="height: 44px;"/>
</a>
